















export default {
  props: {
    // if route is not provided href = page url
    route: {
      type: Object,
      default: () => ({}),
    },
    sunken: Boolean,
  },
};
